import type {
  Demographics,
  LifeExpectancyData,
  LifeExpectancyLookup,
  RegionOption,
  RegionRecord,
} from "./life-expectancy-port";

export function createInMemoryLifeExpectancy(data: LifeExpectancyData): LifeExpectancyLookup {
  const byCode = new Map<string, RegionRecord>(data.regions.map((r) => [r.code, r]));

  return {
    lookup(demographics: Demographics): number {
      const record = byCode.get(demographics.region.code);
      if (!record) {
        throw new Error(`Unknown region code: ${demographics.region.code}`);
      }
      if (raceAppliesTo(record) && demographics.race && record.byRace) {
        return record.byRace[demographics.race][demographics.sex];
      }
      return record.expectancy[demographics.sex];
    },
    regions(): readonly RegionOption[] {
      return data.regions.map(({ kind, code, label }) => ({ kind, code, label }));
    },
  };
}

function raceAppliesTo(record: RegionRecord): boolean {
  return record.kind === "country" && record.code === "US";
}
